// 公共方法

/*
    将数组转化为10进制
    arr:需要转化的数组
* */
function convertToBase10 (arr) {
    const decimalArray = []
    for (let i = 0; i < arr.length; i += 2) {
        // 高位和低位的索引
        const lowIndex = i
        const highIndex = i + 1

        // 获取高位和低位的值
        let low = arr[lowIndex]
        let high = arr[highIndex]
        let decimalValue = 0

        if (high & 0x80) {
            // 将高位左移 8 位，并与低位按位或操作，得到合并后的十进制数
            decimalValue = (high << 8 | low) | 0xFFFF0000
            // 将合并后的十进制数添加到结果数组中
            decimalArray.push(decimalValue)
        } else {
            // 将高位左移 8 位，并与低位按位或操作，得到合并后的十进制数
            decimalValue = (high << 8) | low
            // 将合并后的十进制数添加到结果数组中
            decimalArray.push(decimalValue)
        }
    }
    return decimalArray
}

function convertToArrayWithHighLowDigits(array) {
    const result = [];
    array.forEach(num => {
        let a = num & 0xff
        let b = num >> 8
        result.push(a)
        result.push(b)
    });
    return result;
}

function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}

function reverseConvert(array128) {
    const array64 = [];
    for (let i = 0; i < array128.length; i += 2) {
        const high = array128[i];
        const low = array128[i + 1];
        array64.push(high + low * 256);
    }
    return array64;
}

function rgbToHsv([R, G, B]) {
    console.log([R, G, B])
    R /= 255
    G /= 255
    B /= 255
    const max = Math.max(R, G, B)
    const min = Math.min(R, G, B)
    const range = max - min
    let V = max
    let S = V === 0 ? 0 : range / V
    let H = 0
    if (R === V) H = (60 * (G - B)) / range
    if (G === V) H = 120 + (60 * (B - R)) / range
    if (B === V) H = 240 + (60 * (R - G)) / range

    if (range === 0) H = 0
    if (H < 0) H += 360
    // H = (H / 2) * (256 / 180)
    S *= 100
    V *= 100
    console.log([H, S, V])
    return [H, S, V]
}

// 汉字转Uint8Array
function stringToUint8Array(str) {
    const encoder = new TextEncoder()
    const uint8Array = encoder.encode(str)
    return uint8Array;
}

function convertUint8ArrayToChinese(uint8Array) {
    const textDecoder = new TextDecoder('utf-8')
    const chineseString = textDecoder.decode(uint8Array)
    return chineseString
}

// 将Uint8数组转化为16进制的字符串数组
function arrayToUint16StringArray(arr) {
    return Array.from(arr, num => num.toString(16).padStart(2, '0'));
}

// 封装setTimeout为一个Promise
function delay(ms) {
    let time = 100 // 默认100ms
    if (ms) {
        time = ms
    }
    return new Promise(resolve => setTimeout(resolve, time));
}
function decimalToByteArray(decimalNumber) {
    // 将十进制数转换为32位二进制字符串
    let binaryString = decimalNumber.toString(2).padStart(32, '0');

    // 定义一个数组来存储每个字节的十进制表示
    let byteArray = [];

    // 将32位二进制字符串拆分为四个字节
    for (let i = 0; i < 32; i += 8) {
        let byteBinary = binaryString.substring(i, 8 + i); // 每次取8位
        let decimalValue = parseInt(byteBinary, 2); // 将二进制字符串转换为十进制数
        byteArray.push(decimalValue); // 将每个字节的十进制数存入数组
    }

    return byteArray;
}
function decimalToBinaryArray(decimal) {
    let binaryArray = [];
    let binaryString = decimal.toString(2);
    for (let i = 0; i < binaryString.length; i++) {
        let digit = Number(binaryString[binaryString.length - 1 - i]);
        if (digit === 1) {
            binaryArray.push(Math.pow(2, i));
        }
    }
    return binaryArray;
}

function fetchWithRetry(url, options, retries = 3) {
    return fetch(url, options).then(response => {
        if (!response.ok) {
            if (retries > 0) {
                return fetchWithRetry(url, options, retries - 1);
            }
            throw new Error('Network response was not ok: ' + response.statusText);
        }
        return response
    }).catch(error => {
        if (retries > 0) {
            return fetchWithRetry(url, options, retries - 1);
        }
        throw error;
    });
}



export {
    convertToBase10,
    convertToArrayWithHighLowDigits,
    arraysAreEqual,
    reverseConvert,
    rgbToHsv,
    stringToUint8Array,
    convertUint8ArrayToChinese,
    arrayToUint16StringArray,
    delay,
    decimalToByteArray,
    decimalToBinaryArray,
    fetchWithRetry
}
